import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { AgGridVue } from "ag-grid-vue";
import { UserService } from "@/services";
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import $exponent from "@/mixins/exponent";
import $thousandMask from "@/mixins/thousandMask";
import symbolInTable from "@/components/WalletPage/SymbolInTable/index.vue";
import rangeInTable from "@/components/WalletPage/RangeInTable/index.vue";
import PercentInTable from "@/components/WalletPage/PercentInTable/index.vue";
import AmountInTable from "@/components/WalletPage/AmountInTable/index.vue";
import CurrencyInTable from "@/components/WalletPage/CurrencyInTable/index.vue";
// import updateInTable from "@/components/WalletPage/UpdateInTable/StopLimitOrderTable.vue";
import operationsInTable from "@/components/WalletPage/OperationsInTable/index.vue";
import walletSetting from "@/components/WalletPage/walletSetting/index.vue";
import draggable from "vuedraggable";
import { noRowsTemplate } from "../noRowsTemplate";
import { notLoading } from "../notLoading";

export default {
  name: "wallet-table",
  components: {
    AgGridVue,
    symbolInTable,
    rangeInTable,
    AmountInTable,
    PercentInTable,
    CurrencyInTable,
    // updateInTable,
    operationsInTable,
    walletSetting,
    draggable
  },
  mixins: [$exponent, $thousandMask],
  data() {
    return {
      makeHeaderFixed: false,
      isMenuOpen: false,
      selectedFilter: [1, 2, 3, 4, 5, 6],
      dataTableShow: false,
      showMyPrices: false,
      keySearch: "",
      selected: [],
      arrowTopImage: require("../../../assets/image/up.svg"),
      arrowDownImage: require("../../../assets/image/down.svg"),
      dataTableItem: "",
      gridOptions: null,
      gridApi: null,
      localeText: null,
      columnApi: null,
      walletHeader: null,
      defaultWalletHeader: null,
      paginationPageSize: null,
      paginationNumberFormatter: null,
      tableItemShow: [
        { name: "10", value: 10 },
        { name: "20", value: 20 },
        { name: "30", value: 30 },
        { name: "همه", value: 100 }
      ],
      tableItemShowFirstIndex: 10,
      item: "10"
    };
  },
  // watch: {
  //   filteredWalletHeader(newVal) {
  //         this.gridApi.setColumnDefs(newVal);
  //         this.gridColumnApi.resetColumnState();
  //   }
  // },
  computed: {
    ...mapGetters({
      newWallets: types.wallets.getters.GET_NEW_WALLETS,
      // checkWallets: types.wallets.getters.GET_CHECK_WALLETS,
      exchangeWallets: types.wallets.getters.GET_EXCHANGE_WALLETS,
      userInfo: types.userInfo.getters.GET_USER_INFO,
      userSetting: types.userSetting.getters.GET_USER_SETTING
    }),
    filteredWalletHeader() {
      if (
        this.userSetting.wallet.arrange &&
        this.userSetting.wallet.arrange.length
      ) {
        return this.walletHeader.filter(elem => {
          if (
            this.userSetting.wallet.arrange.find(
              item => elem.colId === item.id && item.enabled
            ) ||
            elem.colId === 0 ||
            elem.colId === 6
          )
            return elem;
        });
      } else return this.walletHeader;
    },
    setWalletData() {
      let data = [];
      if (
        this.newWallets.length > 0
        // Object.entries(this.exchangeWallets).length > 0
        // Object.entries(this.checkWallets).length > 0
      ) {
        for (let elem of this.newWallets) {
          data.push({
            addresses: [],
            currency_id: elem.currency_id,
            name: elem.name,
            name_locale: elem.name_locale,
            symbol: {
              logo: `${process.env.VUE_APP_IMAGE_BASE_URL}/${elem.iso}.svg`,
              name_locale: elem.name_locale,
              iso: elem.iso,
              value: elem.name
            },
            gross_balance: {
              iso: elem.iso,
              amount: this.$thousandMask(elem.balance.total.amount),
              amountSimpleFormat:
                elem.balance.total.equivalent[
                  this.userSetting.wallet.setting.assets_currency_type
                ],
              currency_equivalent: this.$thousandMask(
                elem.balance.total.equivalent[
                  this.userSetting.wallet.setting.assets_currency_type
                ]
              ),
              currency_equivalent_iso: this.userSetting.wallet.setting
                .assets_currency_type,
              isCheckWallet: elem.check_wallet_activated
            },
            balance_blocked: {
              hide: elem.balance.available !== "0",
              amount: this.$thousandMask(elem.balance.blocked),

              iso: elem.iso
            },
            balance: {
              hide: elem.balance.available !== "0",
              amount: this.$thousandMask(elem.balance.available),

              iso: elem.iso
            },
            average_buy_prices: {
              hide: elem.balance.available !== "0",
              dollarFormat: this.userSetting.wallet.setting
                .assets_currency_type,
              amount: this.$thousandMask(
                elem.average_buy_price[
                  this.userSetting.wallet.setting.assets_currency_type
                ]
              ),
              amountSimpleFormat:
                elem.average_buy_price[
                  this.userSetting.wallet.setting.assets_currency_type
                ],
              iso: this.userSetting.wallet.setting.assets_currency_type
            },
            profits_or_losses: {
              hide: elem.balance.available !== "0",
              percents: {
                amountSimpleFormat:
                  elem.profit.percents[
                    this.userSetting.wallet.setting.assets_currency_type
                  ],
                amount: this.$thousandMask(
                  elem.profit.percents[
                    this.userSetting.wallet.setting.assets_currency_type
                  ]
                )
              },
              amounts: {
                amountSimpleFormat:
                  elem.profit.amounts[
                    this.userSetting.wallet.setting.assets_currency_type
                  ],
                amount: this.$thousandMask(
                  Math.abs(
                    elem.profit.amounts[
                      this.userSetting.wallet.setting.assets_currency_type
                    ]
                  )
                ),
                iso: this.userSetting.wallet.setting.assets_currency_type
              }
            },
            operation: {
              isDeposit: elem.actions.deposit_activated,
              isWithdraw: elem.actions.withdraw_activated,
              isExchange: elem.actions.change_activated,
              isTransfer:
                elem.actions.transfer_to_market_activated &&
                this.userInfo.is_market_platform_active,
              iso: elem.iso,
              isCheckWallet: elem.check_wallet_activated
            }
          });
        }

        return data;
      }
    },
    filterWalletData() {
      let data = this.setWalletData;
      // let empty = "";
      // const isString = str => {
      //   let reg = new RegExp(/^([A-Za-z])*$/);
      //   return reg.test(str);
      // };
      if (data) {
        if (this.keySearch) {
          return data.filter(elem => {
            return (
              elem.name_locale
                .replace(/[^\p{L}]/gu, "")
                .toLowerCase()
                .includes(
                  this.keySearch.toLowerCase().replace(/[^\p{L}]/gu, "")
                ) ||
              elem.name
                .replace(/[^\p{L}]/gu, "")
                .toLowerCase()
                .includes(
                  this.keySearch.toLowerCase().replace(/[^\p{L}]/gu, "")
                ) ||
              elem.symbol.iso
                .replace(/[^\p{L}]/gu, "")
                .toLowerCase()
                .includes(
                  this.keySearch.toLowerCase().replace(/[^\p{L}]/gu, "")
                )
            );
          });
        } else {
          return data;
        }
      }
    },
    hideZeroBalanceDataWallet() {
      let data = [];
      if (this.filterWalletData) {
        if (this.showMyPrices) {
          this.filterWalletData.forEach(elem => {
            if (parseFloat(elem.balance.amount) > 0) {
              data.push(elem);
            }
          });
          return data;
        } else {
          return this.filterWalletData;
        }
      }
    }
  },

  beforeMount() {
    this.localeText = {
      to: this.$t("walletPage.walletTable.to"),
      of: this.$t("walletPage.walletTable.of")
    };
    this.gridOptions = {
      domLayout: "autoHeight",
      overlayNoRowsTemplate: noRowsTemplate(
        this.$t("walletPage.noRowsTemplate.noCurrenciesFound")
      ),
      overlayLoadingTemplate: notLoading(
        this.$t("walletPage.notLoading.loading")
      ),
      animateRows: true,
      suppressMovable: true
    };
    this.gridOptions.enableSorting = true;
    this.gridOptions.onCellClicked = false;
    this.setWalletHeader();
    this.defaultWalletHeader = {
      headerClass: "header-table-ag-grid-cell",
      lockPosition: true,
      icons: {
        sortUnSort:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#c1c6cd"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#c1c6cd"></path></svg>',
        sortAscending:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#c1c6cd"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#500fe9"></path></svg>',
        sortDescending:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#500fe9"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#c1c6cd"></path></svg>'
      }
    };
    this.paginationPageSize = 10;
    // this.paginationNumberFormatter = params => {
    //   return "[" + params.value.toLocaleString() + "]";
    // };
  },
  mounted() {
    this.showMyPrices = this.userSetting.wallet.hide_zero_assets;
    this.setSelectedFilters();
    if (this.$route.query.search) {
      this.keySearch = this.$route.query.search;
      this.showMyPrices = false;
    }
    //   this.gridApi = this.gridOptions.api;
    //   this.gridColumnApi = this.gridOptions.columnApi;
    // window.addEventListener("scroll", this.onScroll);
  },
  methods: {
    ...mapActions({
      setUserSetting: types.userSetting.actions.SET_USER_SETTING
    }),
    onScroll() {
      this.makeHeaderFixed = window.scrollY > 300;
    },
    resetFilter() {
      this.selectedFilter = [1, 2, 3, 4, 5, 6];
      this.manipulateWalletHeader();
    },
    onPageSizeChanged(item, name) {
      this.gridApi.paginationSetPageSize(Number(item));
      this.tableItemShowFirstIndex = name;
    },
    setWalletHeader() {
      let tempWalletHeader = [
        {
          colId: 0,
          headerName: this.$t("walletPage.walletTable.symbol"),
          field: "symbol",
          sortable: true,
          unSortIcon: true,
          flex: 1,
          minWidth: 200,
          cellRendererFramework: "symbolInTable",
          headerClass: "update-cell-symbol header-table-ag-grid-cell",
          comparator: (valueA, valueB) => {
            if (valueA.name_locale === valueB.name_locale) return 0;
            return valueA.name_locale > valueB.name_locale ? 1 : -1;
          }
        },
        {
          colId: 1,
          headerName: this.$t("walletPage.walletTable.totalAsset"),
          field: "gross_balance",
          cellRendererFramework: "AmountInTable",
          sortable: true,
          unSortIcon: true,
          flex: 1,
          minWidth: 200,
          comparator: (valueA, valueB) => {
            if (
              parseFloat(valueA.amountSimpleFormat) ===
              parseFloat(valueB.amountSimpleFormat)
            )
              return 0;
            return parseFloat(valueA.amountSimpleFormat) >
              parseFloat(valueB.amountSimpleFormat)
              ? 1
              : -1;
          }
        },
        {
          colId: 2,
          headerName: this.$t("walletPage.walletTable.averagePurchasePrice"),
          field: "average_buy_prices",
          cellRendererFramework: "CurrencyInTable",
          sortable: true,
          unSortIcon: true,
          flex: 1,
          minWidth: 170,
          comparator: (valueA, valueB) => {
            if (
              parseFloat(valueA.amountSimpleFormat) ===
              parseFloat(valueB.amountSimpleFormat)
            )
              return 0;
            return parseFloat(valueA.amountSimpleFormat) >
              parseFloat(valueB.amountSimpleFormat)
              ? 1
              : -1;
          }
        },
        {
          colId: 3,
          headerName: this.$t("walletPage.walletTable.profitLoss"),
          field: "profits_or_losses",
          sortable: true,
          unSortIcon: true,
          cellRendererFramework: "PercentInTable",
          flex: 1,
          minWidth: 170,
          comparator: (valueA, valueB) => {
            if (
              parseFloat(valueA.amounts.amountSimpleFormat) ===
              parseFloat(valueB.amounts.amountSimpleFormat)
            )
              return 0;
            return parseFloat(valueA.amounts.amountSimpleFormat) >
              parseFloat(valueB.amounts.amountSimpleFormat)
              ? 1
              : -1;
          }
        },
        {
          colId: 4,
          headerName: this.$t("walletPage.walletTable.blockedAsset"),
          field: "balance_blocked",
          cellRendererFramework: "CurrencyInTable",
          sortable: true,
          unSortIcon: true,
          flex: 1,
          minWidth: 170,
          comparator: (valueA, valueB) => {
            if (parseFloat(valueA.amount) === parseFloat(valueB.amount))
              return 0;
            return parseFloat(valueA.amount) > parseFloat(valueB.amount)
              ? 1
              : -1;
          }
        },
        {
          colId: 5,
          headerName: this.$t("walletPage.walletTable.availableAsset"),
          field: "balance",
          cellRendererFramework: "CurrencyInTable",
          sortable: true,
          unSortIcon: true,
          flex: 1,
          minWidth: 170,
          comparator: (valueA, valueB) => {
            if (parseFloat(valueA.amount) === parseFloat(valueB.amount))
              return 0;
            return parseFloat(valueA.amount) > parseFloat(valueB.amount)
              ? 1
              : -1;
          }
        },
        {
          colId: 6,
          headerName: this.$t("walletPage.walletTable.operation"),
          field: "operation",
          pinned: this.$vuetify.breakpoint.smAndDown
            ? ""
            : this.$vuetify.rtl
            ? "left"
            : "right",
          width: this.$vuetify.rtl ? 300 : 300,
          headerClass: "operation-cell header-table-ag-grid-cell",
          cellRendererFramework: "operationsInTable"
        }
      ];

      let headers = [];
      this.userSetting.wallet.arrange.forEach(elem => {
        tempWalletHeader.find(item => {
          if (item.colId === elem.id) headers.push(item);
        });
      });
      this.walletHeader = headers;
    },
    setSelectedFilters() {
      if (
        this.userSetting.wallet.arrange &&
        this.userSetting.wallet.arrange.length
      ) {
        this.selectedFilter = [];
        this.userSetting.wallet.arrange.forEach(e => {
          if (e.enabled) this.selectedFilter.push(e.id);
        });
      }
    },
    setHideZeroAssets() {
      let data = this.userSetting;
      data.wallet.hide_zero_assets = this.showMyPrices;
      this.updateUserSetting(data);
    },
    manipulateWalletHeader() {
      let data = this.userSetting;
      data.wallet.arrange = [];
      this.walletHeader.forEach(elem => {
        if (this.selectedFilter.includes(elem.colId)) {
          data.wallet.arrange.push({
            id: elem.colId,
            enabled: true
          });
        } else {
          data.wallet.arrange.push({
            id: elem.colId,
            enabled: false
          });
        }
      });
      this.updateUserSetting(data);
    },
    updateUserSetting(data) {
      UserService.setSetting(data).then(res => {
        this.setUserSetting(res.data.data);
      });
    }
  }
};
